import React from 'react'
import Dropdown from 'blocks.simple/dropdown/dropdown'
import translate from 'core/translate'
import { cn } from 'ethcss'
import styles from './deviceSettings__logLevel.jcss'
import { Typography } from 'atoms/Typography'
import Checkbox from '../../../blocks.simple/checkbox/checkbox'

const DeviceSettingsLogLevel = (p_: {
    enabled: boolean
    value: { writeSystemLog: boolean; logLevel: string }
    onChange: (logLevel: any, field: string, cb?: () => void) => void
    platform?: string
}) => {
    if (!p_.enabled) {
        return null
    }

    const logLevelOptions = [
        { id: 'Trace', name: 'Trace' },
        { id: 'Debug', name: 'Debug' },
        { id: 'Info', name: 'Info' },
        { id: 'Warn', name: 'Warn' },
        { id: 'Error', name: 'Error' },
        { id: 'Fatal', name: 'Fatal' },
        { id: 'Off', name: translate('off') },
    ]

    return (
        <div>
            {p_.platform === 'android' && (
                <div className={styles.checkboxWrapper}>
                    <Typography className={cn(styles.title)} type="title">
                        {translate('OSMessages')}
                    </Typography>
                    <div className={styles.checkbox}>
                        <Checkbox
                            onClick={(checked: any) => {
                                p_.onChange(checked, 'writeSystemLog')
                            }}
                            checked={p_.value.writeSystemLog}
                            label={translate('writeOSMessages')}
                            labelClassName={styles.label}
                        />
                    </div>
                </div>
            )}
            <Typography className={cn(styles.title)} type="title">
                {translate('logLevel')}
            </Typography>
            <div className={styles.dropdownWrapper}>
                <Dropdown
                    value={p_.value.logLevel}
                    options={logLevelOptions}
                    onChange={function (logLevel) {
                        p_.onChange(logLevel.id, 'logLevel', () => {
                            if (p_.platform !== 'android') return

                            if (logLevel.id === 'Debug' || logLevel.id === 'Trace') {
                                p_.onChange(true, 'writeSystemLog')

                                return
                            }

                            p_.onChange(false, 'writeSystemLog')
                        })
                    }}
                />
            </div>
        </div>
    )
}

export default React.memo(DeviceSettingsLogLevel)
